<template>
  <div>
    <PageTitle v-bind:title="title" v-bind:admin="false" />
    <TheCoursesMenu v-bind:index="3" />

    <!-- <QuoteTest /> -->

    <ErrorMessage v-if="errors.load" :error="errors.load" class="mt-4" />

    
    <div
      class="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8"
    >
      <div class="absolute inset-0">
        <div class="bg-white h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative max-w-7xl mx-auto">
        <div class="text-center">
          <h2
            class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
          >
            Пройденные курсы
          </h2>
          <!--
          <p class="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
            libero labore natus atque, ducimus sed.
          </p>
          -->
        </div>
        <!--
        <div
          class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none"
        >
          <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <div class="flex-shrink-0">
              <img
                class="h-48 w-full object-cover"
                src="https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixqx=xc9myIFc3S&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80"
                alt=""
              />
            </div>
            <div class="flex-1 bg-white p-6 flex flex-col justify-between">
              <div class="flex-1">
                <a href="#" class="block mt-2">
                  <p class="text-xl font-semibold text-gray-900">Course</p>
                </a>
                <div class="flex mt-2">
                  <div
                    v-for="index in 5"
                    :key="index"
                    class="flex items-center mt-2 mb-4"
                  >
                    <svg
                      :class="[
                        'mx-1 w-4 h-4 fill-current',
                        5 >= index ? 'text-yellow-500' : 'text-gray-400',
                      ]"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="text-sm text-gray-500">
                <p>Начат: 3/1/2021</p>
                <p>Закончен: 3/8/2021</p>
              </div>
            </div>
          </div>
        </div>
        -->
      </div>
    </div>
    



    <Loader v-if="loading" />

    <div
      v-else
      v-for="item in data.courses"
      v-bind:key="item.id"
      class="flex flex-col rounded-lg shadow-lg overflow-hidden"
    >
      <div class="flex-shrink-0">
        <img class="h-48 w-full object-cover" :src="item.image" alt="" />
      </div>
      <div class="flex-1 bg-white p-6 flex flex-col justify-between">
        <div class="flex-1">
          <p class="text-sm font-medium text-cyan-600">
            <a href="#" class="hover:underline">
              {{ item.department.name }}
            </a>
          </p>
          <a href="#" class="block mt-2">
            <p class="text-xl font-semibold text-gray-900">
              <router-link
                :to="{ name: 'course_show', params: { id: item.id } }"
                >{{ item.name }}</router-link
              >
            </p>
            <!-- <p>
                   <span :class="{ 'card__rating--filled': item.rating >= 1 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 2 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 3 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 4 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 5 }"
                  >☆</span
                >
            </p> -->
            <!-- <p class="mt-3 text-base text-gray-500">
              {{ course.description }}
            </p> -->
          </a>
        </div>
        <div class="mt-6 flex items-center">
          <p>Начат: {{ localeDate(item.pivot.started_at) }}</p>
          <p class="mt-4">Закончен: {{ localeDate(item.pivot.finished_at) }}</p>
        </div>
      </div>
    </div>

    <!--
    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div v-for="item in data.courses" v-bind:key="item.id" class="col mt-2">
        <div class="card h-100">
          <div
            style="height: 200px; background-size: cover"
            v-bind:style="{ 'background-image': 'url(' + item.image + ')' }"
          ></div>
          <div class="card-body">
            <h5 class="card-title">
              <router-link
                :to="{ name: 'course_show', params: { id: item.id } }"
                >{{ item.name }}</router-link
              >&nbsp;
            </h5>
            <div class="card-text">
              <div class="card__rating">
                <span :class="{ 'card__rating--filled': item.rating >= 1 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 2 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 3 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 4 }"
                  >☆</span
                >
                <span :class="{ 'card__rating--filled': item.rating >= 5 }"
                  >☆</span
                >
              </div>
            </div>
          </div>
          <div class="card-footer">
            <small class="text-muted">
              <p class="m-0">Начат: {{ localeDate(item.pivot.started_at) }}</p>
              <p class="m-0">
                Закончен: {{ localeDate(item.pivot.finished_at) }}
              </p>
            </small>
          </div>
        </div>
      </div>
    </div>
    -->

    <!-- <TestCards /> -->
  </div>
</template>

<script>
import TheCoursesMenu from "@/components/TheCoursesMenu";
import PageTitle from "@/components/PageTitle";
import Loader from "@/components/Loader";
// import TestCards from '@/components/TestCards'
// import QuoteTest from "@/components/QuoteTest";
import axios from "axios";
import ErrorMessage from "@/components/ErrorMessage";

// import axios from 'axios'
export default {
  components: {
    TheCoursesMenu,
    PageTitle,
    Loader,
    // TestCards,
    // QuoteTest,
    ErrorMessage,
  },
  data() {
    return {
      data: [],
      title: "Курсы",
      loading: true,
      errors: { load: "" },
    };
  },
  async mounted() {
    // загрузка данных:
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("courses/done");
        this.data = response.data;
        //this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    localeDate(d) {
      // Конвертируем число в строку. Для этого существуют специальные методы
      // toLocaleDateString() или toLocaleString() или toLocaleTimeString()
      // Итоговая строка будет зависеть от локализации системы пользователя.
      // Для русской локали это будет "01.02.2020",
      // для американской "2/1/2020",
      // для немецкой — "1.2.2020"
      // Вы НЕ должны устанавливать формат даты самостоятельно
      if (d) return new Date(d).toLocaleDateString();
      else return null;
    },
  },
};
</script>



<style  scoped>
.card__rating {
  color: orange;
}

.card__rating > span {
  font-size: 30px;
  line-height: 0.5;
}

.card__rating--filled:before {
  content: "\2605";
  position: absolute;
}
</style>